import { useFind } from '@geprog/use-feathers';

import useFeathers from '#/compositions/useFeathers';

import { ClientApplication } from './useFeathers';

export default useFind<ClientApplication>(useFeathers());
